import { FaPhone, FaEnvelope } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bottom-0 left-0 w-full blue-bg p-4 shadow-md py-10">
      {/* Header */}
      <h1 className="text-2xl font-nunito text-white mx-20 pb-10">Nisa & Sabir Foundation</h1>

      {/* Grid Panel */}
      <div className="mx-20 grid grid-cols-1 md:grid-cols-2 gap-10 text-sm text-white">
        {/* Column 1: Links */}
        <div className="space-y-4">
          <div>
            <Link to="/our-projects" className="hover:underline">Our Projects</Link>
          </div>
          <div>
            <Link to="/donate" className="hover:underline">Donate Now</Link>
          </div>
          <div>
            <Link to="/contact" className="hover:underline">Contact Us</Link>
          </div>
        </div>

        {/* Column 2: Call to Action + Contact Info */}
        <div className="space-y-4">
          <div>
            Want to help? <Link to="/get-involved" className="text-white underline">Get Involved!</Link>
          </div>
          <div className="flex items-center space-x-2">
            <FaPhone />
            <a href="tel:+14806780796" className="hover:underline">(480) 678-0796</a>
          </div>
          <div className="flex items-start space-x-2 break-words max-w-full">
            <FaEnvelope className="min-w-[1rem] mt-1" />
            <a
              href="mailto:nisaandsabirfoundation@gmail.com"
              className="hover:underline break-words"
            >
              nisaandsabirfoundation@gmail.com
            </a>
          </div>
        </div>
      </div>

      {/* CopyRight */}
      <div className="mx-20 pt-10">
        <p className="text-white">© 2024 Nisa & Sabir Foundation. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
